module.exports = __webpack_public_path__ + "img/empty-user.ccbfadc4.svg";